import { createSubstore } from 'storeon-substore';
import type { Store } from 'store/types';
import { getProducts } from './products-actions';
import { FETCH_PRODUCTS, PRODUCTS_STORE_NAME } from './products-constants';
import type { LoadingStatus, ProductsStore } from './products-types';

const INITIAL_STATE: ProductsStore = {
  productList: null,
  loading: false,
  loadingStatus: null,
  error: null,
} as const;

export const products = (parentStore: Store) => {
  const store = createSubstore(parentStore, PRODUCTS_STORE_NAME);
  store.on('@init', () => INITIAL_STATE);
  store.on(FETCH_PRODUCTS.init, async (_, { productIdList, sectionName }) => {
    const { productList, loading } = store.get();
    const { modelJson, apiKey, orchestratorHost, useCredentials, requestID } = parentStore.get();

    if (!modelJson.model || loading) {
      return Promise.resolve();
    }

    if (productList && productIdList.every((productId: string) => productList[productId])) {
      return Promise.resolve();
    }

    if (sectionName) {
      store.dispatch(FETCH_PRODUCTS.loading, { [sectionName]: 'Pending' });
    } else {
      store.dispatch(FETCH_PRODUCTS.request);
    }

    try {
      const result = await getProducts(productIdList, modelJson.model.properties.regionId, {
        apiKey,
        orchestratorHost,
        useCredentials,
        requestID,
      });
      store.dispatch(FETCH_PRODUCTS.success, result);
    } catch (e) {
      store.dispatch(FETCH_PRODUCTS.failure, (e as Error).message);
    }

    if (sectionName) {
      store.dispatch(FETCH_PRODUCTS.loading, { [sectionName]: 'Loaded' });
    }

    return Promise.resolve();
  });
  store.on(FETCH_PRODUCTS.request, state => ({ ...state, loading: true }));
  store.on(FETCH_PRODUCTS.loading, (state, status: Record<string, LoadingStatus>) => ({
    ...state,
    loadingStatus: { ...state.loadingStatus, ...status },
  }));
  store.on(FETCH_PRODUCTS.failure, (state, error) => ({
    ...state,
    error,
    loading: false,
    productList: null,
  }));
  store.on(FETCH_PRODUCTS.success, (state, res) => ({
    ...state,
    productList: { ...state.productList, ...res },
    loading: false,
  }));
};
